export function executeSafely<T>(fn: () => T | Promise<T>): Promise<T | undefined> {
  return Promise.resolve()
    .then(fn)
    .catch((error: unknown) => {
      console.error('[ACUL]', error)
      throw error
    })
}

export function getPreviewScreen(): string {
  const params = new URLSearchParams(window.location.search)
  return (
    params.get('screen') ||
    import.meta.env.VITE_PREVIEW_SCREEN ||
    'login-id'
  )
}
